import { useEffect, useState } from "react";
import { BasicPage } from "../../../theme/Component/BasicPage"
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single, _WorkMaintenanceOrder } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable, MASK_BOOLEAN, MASK_BOOLEAN_ICON, MASK_DATE, MASK_MONEY } from "../../../theme/Component/BasicTable";
import usePaginator from "../../../theme/Component/usePaginator";
import { Modal } from "../../../theme/Component/Modal";
import { HandlerInfoProcess } from "../../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import useModal, { MODAL_LG, MODAL_md } from "../../../theme/Component/hooks/useModal";
import { FixedAssetReplacementByWorkMaintenance } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/WorkMaintenanceOrder/FixedAssetReplacementByWorkMaintenance";
import { SelectTechnicians } from "../Technicians/SelectTechnicians";
import { SelectSeverityLevels } from "../SeverityLevels/SelectSeverityLevels";
import { SelectErrorDetails } from "../ErrorTypes/ErrorDetails/SelectErrorDetails";
import { AdquisitionItemEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdquisitionItemEditor";
import { AdquisitionItemSelector } from "../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { toast } from "react-toastify";
import { AtachDocument } from "../../../theme/Component/AtachDocument";
import { InputDate } from "../../../theme/Input/InputDate";
import { DropDown } from "../../../theme/Component/DropDown";
import { RequestMaintenanceStatst } from "./Components/RequestMaintenanceStats";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { RequestMaintenanceImplements } from "./Components/RequestMaintenanceImplements";
import { EditorFixedAssetItemByOperationState } from "../../../editor/AssetItemsByOperationState/EditorFixedAssetItemByOperationState";
import { PrintJson } from "../../../theme/Component/PrintJson";

interface Form {
    State: number;
    Location: number;
    Technician: number;
    UsedSpared: number;
    PriorityMaintenance: number;
    Turn: string;
    ErrorDetails: number;
    fromDate: string;
    uptoDate: string;
    CodeInternal: string;
}

interface Props {
    isModal?: boolean;
    filterProps?: any;
}

export const RequestMaintenance = ({ isModal, filterProps }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_RequestMaintenance);
    const { instance: orderService } = useDataBean(_WorkMaintenanceOrder);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [form, setForm] = useState<Partial<Form>>({})
    const paginador = usePaginator();

    const modalEdit = useModal(`Editar Historial de ${bean.DescriptionFixed}`, MODAL_LG);
    const modalReplacement = useModal(`Catalogo de Repuestos Solicitados de ${bean.DescriptionFixed}`, MODAL_md);
    const modalImplements = useModal(`Catalogo de Implementos Utilizados de ${bean.DescriptionFixed}`, MODAL_LG);
    const modalAdquisition = useModal(`Necesidad Asociada de ${bean.DescriptionFixed}`, MODAL_LG);
    const modalDocs = useModal(`Documentos adjuntos de ${bean.DescriptionFixed}`, MODAL_md);
    const modalFrecuency = useModal(`Frecuencia de Fallos`, MODAL_LG);
    const modalDelete = useModal(`Eliminar Historial de Mantenimiento`, MODAL_md);
    const modalExportList = useModal(`Eliminar Historial de Mantenimiento`, MODAL_md);
    const modalConfirmWorkMaintenance = useModal(`Validación de orden de trabajo`, MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        let props: any = {
            State: form.State,
        }

        if (form.Location) props.IDLocation = form.Location;
        if (form.Technician) props.IDTechnicians = form.Technician;
        if (form.UsedSpared) props.UsedSparedParts = form.UsedSpared;
        if (form.PriorityMaintenance) props.IDPriorityMaintenance = form.PriorityMaintenance;
        if (form.Turn) props.CodeTurno = form.Turn;
        if (form.ErrorDetails) props.IDErrorDetails = form.ErrorDetails;


        if (filterProps) {
            props = {
                ...filterProps,
                ...props
            }

        }


        instance.getRequestMaintenanceRender(1, 15 * paginador.pages, props, form.fromDate, form.uptoDate).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach((item: any) => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    if (!item.DataBeanProperties) {
                        item.DataBeanProperties = {};
                    }

                    const d = item.DataBeanProperties;

                    d.ErrorDetailEntity = d.IDErrorDetails ? `${d.ErrorDetailCode ?? ""} - ${d.ErrorDetailName}` : "N/P";
                    d.HoraReporte = d.ReportTimeH ? `${pad(d.ReportTimeH ?? 0)}:${pad(d.ReportTimeM ?? 0)}` : "N/P";
                    d.HoraMantenimeinto = d.ReviewFromH ? `${pad(d.ReviewFromH ?? 0)}:${pad(d.ReviewFromM ?? 0)}` : "N/P";
                    d.HoraEntrega = d.DeliveryToH ? `${pad(d.DeliveryToH ?? 0)}:${pad(d.DeliveryToM ?? 0)}` : "N/P";
                    d.TechnicianEntityOk = d.TecnicianNit ? `${d.TecnicianNit} - ${d.TecnicianEntity}` : "N/P";
                    d.IDAdquisitioState = d.IDAdquisitionItem ? "Si" : "No";
                    d.IsPlan = d.IsPlan ? "Si" : "No";
                    d.UsedSparedParts = d.UsedSparedParts ? "Si" : "No";
                    d.TotalValue = d.TechnicianValue && d.TotalHorasParoMinutos ? getTotalValue(d.TotalHorasParoMinutos, d.TechnicianValue / 60) : 0;

                });
                setListaExport(resp.List);
                modalExportList.open();
            }
        )
    }

    const getTotalValue = (totalMinutes: number, valuePerMinute: number) => {
        if (totalMinutes > 0 && valuePerMinute > 0) {
            const value = totalMinutes * valuePerMinute;
            return value;
        } else {
            return null;
        }
    }


    const getLista = () => {
        let props: any = {
            State: form.State,
        }

        if (form.Location) props.IDLocation = form.Location;
        if (form.Technician) props.IDTechnicians = form.Technician;
        if (form.UsedSpared) props.UsedSparedParts = form.UsedSpared;
        if (form.PriorityMaintenance) props.IDPriorityMaintenance = form.PriorityMaintenance;
        if (form.Turn) props.CodeTurno = form.Turn;
        if (form.ErrorDetails) props.IDErrorDetails = form.ErrorDetails;
        if (form.CodeInternal) props.FixedAssetItemCode = form.CodeInternal;

        if (filterProps) {
            props = {
                ...filterProps,
                ...props
            }

        }

        instance.getRequestMaintenanceRender(paginador.page, 15, props, form.fromDate, form.uptoDate).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach((item: any) => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    if (!item.DataBeanProperties) {
                        item.DataBeanProperties = {};
                    }

                    const d = item.DataBeanProperties;

                    d.ErrorDetailEntity = d.IDErrorDetails ? `${d.ErrorDetailCode ?? ""} - ${d.ErrorDetailName}` : "N/P";
                    d.HoraReporte = `${d.ReportTimeH ? `${pad(d.ReportTimeH ?? 0)}:${pad(d.ReportTimeM ?? 0)}` : "N/P"}`;
                    d.HoraMantenimeinto = `${d.ReviewFromH ? `${pad(d.ReviewFromH ?? 0)}:${pad(d.ReviewFromM ?? 0)}` : "N/P"}`;
                    d.HoraEntrega = `${d.DeliveryToH ? `${pad(d.DeliveryToH ?? 0)}:${pad(d.DeliveryToM ?? 0)}` : "N/P"}`;
                    d.TechnicianEntityOk = d.TecnicianNit ? `${d.TecnicianNit} - ${d.TecnicianEntity}` : "N/P";
                    d.IDAdquisitioState = d.IDAdquisitionItem ? true : false;
                    d.TotalValue = d.TechnicianValue && d.TotalHorasParoMinutos ? getTotalValue(d.TotalHorasParoMinutos, d.TechnicianValue / 60) : 0;
                });
                setLista(resp.List);
            }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Frecuencia de Fallas', permiso: null, activo: true },
        { id: 2, name: 'Generar Reporte', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={actions} />
                </div>
            </div>
        )
    }

    const actions = (e: any) => {
        if (e.id === 1) {
            modalFrecuency.open();
        }
        if (e.id === 2) {
            getListaExport();
        }
    }

    const head = [
        { title: 'ID', property: 'IDRequestMaintenance', visible: true },
        { title: 'Codigo Interno', property: 'FixedAssetItemCode', visible: true },
        { title: 'Maquina', property: 'DescriptionFixed', visible: true },
        // { title: 'Area de Matenimiento', property: '', visible: true },
        { title: 'Fecha del Reporte', property: 'ReportDate', visible: true, mask: MASK_DATE },
        { title: 'Hora del Reporte', property: 'HoraReporte', visible: true },
        { title: 'Fallo Reportado', property: 'Observations', visible: true },
        { title: 'Codigo del Tecnico', property: 'CodeTechnician', visible: true },
        { title: 'Nombre del Tecnico', property: 'TechnicianEntityOk', visible: true },
        { title: 'Valor/Hora del Tecnico', property: 'TechnicianValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Total', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Turno de Producción', property: 'CodeTurno', visible: true },
        { title: 'Fallo Evidenciado por el Tecnico', property: 'DescriptionOperator', visible: true },
        { title: 'Fecha de Revisión', property: 'ReviewDate', visible: true, mask: MASK_DATE },
        { title: 'Hora de Revisión', property: 'HoraMantenimeinto', visible: true },
        { title: 'Fecha de Entrega', property: 'DeliveryDate', visible: true, mask: MASK_DATE },
        { title: 'Hora de Entrega', property: 'HoraEntrega', visible: true },
        { title: 'Actividad Realizada', property: 'ActivityDescription', visible: true },
        { title: 'Tiempo de Paro de la Maquina', property: 'TotalHorasParoHHMM', visible: true },
        { title: 'Tiempo de Paro de la Maquina (Minutos)', property: 'TotalHorasParoMinutos', visible: true },
        { title: 'Estado del Mantenimiento', property: 'StateName', visible: true },
        { title: 'Codigo del Mantenimiento', property: 'ProdecureCode', visible: true },
        { title: 'Error Presentado', property: 'ErrorDetailEntity', visible: true },
        { title: 'Prioridad', property: 'SeverityName', visible: true },
        { title: '¿es de Plan de Mantenimientos?', property: 'IsPlan', visible: true, mask: MASK_BOOLEAN },
        { title: '¿Se Solicitaron Repuestos?', property: 'UsedSparedParts', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Necesidad Asociada', property: 'IDAdquisitioState', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Jusitificación de la Necesiad', property: 'AdquisitionDescription', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
            { titulo: 'Historial del Procedimiento', icono: 'ri-history-line', visible: true, evento: () => { setModal({ ...modal, "name": `Historial del mantenimiento`, "view": true }) } },
            { titulo: 'Repuestos Solicitados', icono: 'ri-list-check', visible: bean.IDWorkMaintenanceOrderData, evento: () => { modalReplacement.open() } },
            { titulo: 'Implementos Solicitados', icono: 'ri-list-check', visible: true, evento: () => { modalImplements.open() } },
            { titulo: 'Asociar Adquisisción PAA', icono: 'ri-upload-2-fill', visible: bean.IDWorkMaintenanceOrderData, evento: () => { modalAdquisition.open() } },
            { titulo: 'Documentos Asociados', icono: 'ri-list-check', visible: bean.JSONListDocument, evento: () => { modalDocs.open() } },
            { titulo: 'Validar orden de Trabajo Asociada', icono: 'ri-checkbox-circle-line', visible: !bean.IDWorkMaintenanceOrderData && bean.State == 4, evento: () => { createWorkMaintenance() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        instance.updateRequestMaintenance({ ...bean, State: 5 }).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(
            err => { toast.error("No se pudo realizar la Acción") }
        )
    }

    const assingPAA = () => {
        instance.updateRequestMaintenance(bean).then(
            (resp) => {
                getLista();
                modalAdquisition.close();
                modalEdit.close();
            }

        ).catch(err => { toast.error(err) })
    }

    const createWorkMaintenance = () => {
        orderService.updateWorkMaintenanceOrder({
            IDEmployee: bean.IDEmployee,
            State: 8,
            Since: bean.ReviewDate,
            IDRequestMaintenance: bean.IDRequestMaintenance,
            IDItem: bean.IDFixedAssetItem,
            Observations: `${bean.IDFixedAssetItemName} - ${bean.ProdecureCode} - ${bean.Observations} `,
        }).then(
            (resp) => {
                getLista();
                orderService.changeWorkMaintenanceOrderState(resp?.IDWorkMaintenanceOrder, 8).then(
                    (resp) => {
                        toast.success(`Se asocio la orden de trabajo ${resp?.IDWorkMaintenanceOrder}`);
                    }
                ).catch(() => { toast.success(`Se asocio la orden de trabajo ${resp?.IDWorkMaintenanceOrder}, estado borrador`); })
            }
        ).catch(() => { toast.error("No se pudo validar la orden de trabajo") })
    }

    const [document, setDocument] = useState<any>([]);

    useEffect(() => {
        if (bean.JSONListDocument) {
            setDocument(JSON.parse(bean.JSONListDocument))
        }
    }, [bean.IDRequestMaintenance])

    useEffect(() => {
        setBean({ ...bean, JSONListDocument: JSON.stringify(document) })
    }, [document]);

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="" value={form.fromDate} setDate={(e) => { setForm({ ...form, fromDate: e }) }} label="Fecha desde" />
                </div>
                <div className="col-md-4">
                    <InputDate name="" value={form.uptoDate} setDate={(e) => { setForm({ ...form, uptoDate: e }) }} label="Fecha hasta" />
                </div>
                <div className="col-md-4">
                    <label>Estado</label>
                    <select className="form-select" value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, State: value })
                    }} >
                        <option value="">...</option>
                        <option value={1}>Reportado</option>
                        <option value={2}>Asignado</option>
                        <option value={3}>En Mantenimiento</option>
                        <option value={4}>Finalizado</option>
                        <option value={5}>Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <SelectTechnicians
                        idSelector={form.Technician}
                        returnType="ID"
                        label="Asignar Tecnico a Cargo"
                        onChange={(e) => { setForm({ ...form, Technician: e }) }}
                    />
                </div>
                <div className="col-md-4">
                    <SelectSeverityLevels returnType="ID" idSelector={form.PriorityMaintenance} onChange={(e) => { setForm({ ...form, PriorityMaintenance: e }) }} label="Prioridad de Mantenimiento" />
                </div>
                <div className="col-md-4">
                    <SelectErrorDetails idSelector={form.ErrorDetails} onChange={(e) => { setForm({ ...form, ErrorDetails: e }) }} label="Codigo de Error" returnType="ID" />
                </div>
                <div className="col-md-4">
                    <label>Turno</label>
                    <select className="form-select" value={form.State} onChange={(e) => { setForm({ ...form, Turn: e.target.value }) }} >
                        <option value="">...</option>
                        <option value={"A"}>Turno A</option>
                        <option value={"B"}>Turno B</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label>¿Se Solicito Repuestos?</label>
                    <select
                        className="form-select"
                        value={form.UsedSpared}
                        onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null
                            setForm({ ...form, UsedSpared: value });
                        }}
                    >
                        <option value="">...</option>
                        <option value="0">No</option>
                        <option value="1">Si</option>
                    </select>
                </div>

                <div className="col-md-4">
                    <label>Codigo Interno</label>
                    <input type="text" value={form.CodeInternal} onChange={(e) => { setForm({ ...form, CodeInternal: e.target.value }) }} className="form-control" />
                </div>

                <div className="col-md-2 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"buscar"} />
                </div>

                <div className="col-md-12">
                    <BasicTable
                        headButtons={buttons()}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProceudreIMP} />
                    </Modal>

                    <Modal modal={modalDocs.modal} updateModal={modalDocs.setModal} >
                        <AtachDocument _docList={bean.JSONListDocument ? JSON.parse(bean.JSONListDocument) : []} onChange={() => { }} onlyView />
                    </Modal>

                    <Modal modal={modalReplacement.modal} updateModal={modalReplacement.setModal} >
                        <FixedAssetReplacementByWorkMaintenance idWorkMaintenanceOrder={bean.IDWorkMaintenanceOrderData} />
                    </Modal>

                    <Modal modal={modalAdquisition.modal} updateModal={modalAdquisition.setModal} eventModal={() => {
                        if (bean.IDAdquisitionItem) {
                            assingPAA()
                        } else {
                            toast.error("Necesidad no Valida")
                        }
                    }} >
                        <div className="row">
                            <div className="col-md-8">
                                <AdquisitionItemSelector ConfigProps={{ label: "Necesidad del plan Anual", notSeeProps: true }} onChage={(e) => { setBean({ ...bean, IDAdquisitionItem: e.IDAdquisitionItem }) }} idAdquisitionItem={bean.IDAdquisitionItem} />
                            </div>
                            {bean.IDAdquisitionItem &&
                                <div className="col-md-4 mt-4">
                                    <AdquisitionItemEditor IDAquisitionItem={bean.IDAdquisitionItem} ConfigProps={{ visualization: "button", label: "Ver Necesdiad" }} />
                                </div>
                            }
                        </div>
                    </Modal>

                    <Modal modal={modalFrecuency.modal} updateModal={modalFrecuency.setModal}  >
                        <RequestMaintenanceStatst />
                    </Modal>

                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { assingPAA() }} >
                        <div className="row">

                            <div className="col-md-6">
                                <InputDate label="Fecha de Reporte" name="" value={bean.ReportDate} setDate={(e) => { setBean({ ...bean, ReportDate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora de Reporte</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReportTimeH ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReportTimeH: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReportTimeM ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReportTimeM: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(60)].map((_, i) => (
                                                <option key={i * 1} value={i * 1}>{(i * 1).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <hr />
                                <h5>Maquina Seleccionada</h5>
                            </div>

                            <div className="col-md-6">
                                <label>Maquina</label>
                                <EditorFixedAssetItemByOperationState renderMachine={bean.IDFixedAssetItemName} idSelector={bean.IDFixedAssetItem} label="" onChange={(e) => { setBean({ ...bean, IDFixedAssetItem: e.IDItem }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectSeverityLevels returnType="Object" idSelector={bean.IDPriorityMaintenance} onChange={(e) => { setBean({ ...bean, IDPriorityMaintenance: e?.IDSeverityLevels, RenderPriorityMaintenance: e?.Name }) }} label="Prioridad de Mantenimiento" />
                            </div>
                            <div className="col-md-6">
                                <SelectErrorDetails idSelector={bean.IDErrorDetails} onChange={(e) => {
                                    const value = e?.IDErrorDetails ? `${e?.CodeError} - ${e?.Name}` : "N/A";
                                    setBean({ ...bean, IDErrorDetails: e?.IDErrorDetails, RenderIDErrorDetails: value })
                                }} label="Codigo de Error" returnType="Object" />
                            </div>

                            <div className="col-md-6">
                                <label>Turno de Producción</label>
                                <select value={bean.CodeTurno} onChange={(e) => { setBean({ ...bean, CodeTurno: e.target.value }) }} className="form-select">
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                </select>
                            </div>

                            <div className="col-md-12">
                                <label>Descripción de la Falla</label>
                                <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} />
                            </div>

                            <div className="col-md-12"><hr /></div>

                            <div className="col-md-12">
                                <SelectTechnicians
                                    idSelector={bean.IDTechnicians}
                                    returnType="Object"
                                    label="Asignar Tecnico a Cargo"
                                    onChange={(e) => {
                                        const tech = e.IDTechnicians ? e : {}
                                        setBean((prev) => ({ ...prev, IDTechnicians: tech?.IDTechnicians, }))
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Hora de Ejecución de la actividad</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReviewFromH ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReviewFromH: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReviewFromM ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReviewFromM: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(60)].map((_, i) => (
                                                <option key={i * 1} value={i * 1}>{(i * 1).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <InputDate label="Fecha de Revision de la maquina" name="ReviewDate" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Error Evidenciado (Tecnico)</label>
                                <textarea className="form-control" value={bean.DescriptionOperator} onChange={(e) => { setBean({ ...bean, DescriptionOperator: e.target.value }) }} />
                            </div>
                            <div className="col-md-12"><hr /></div>
                            <div className="col-md-6">
                                <InputDate name="" label="Fecha de Entrega" value={bean.DeliveryDate} setDate={(e) => { setBean({ ...bean, DeliveryDate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora de Entrega de la maquina</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.DeliveryToH ?? ""}
                                            onChange={(e) => setBean({ ...bean, DeliveryToH: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.DeliveryToM ?? ""}
                                            onChange={(e) => setBean({ ...bean, DeliveryToM: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(60)].map((_, i) => (
                                                <option key={i * 1} value={i * 1}>{(i * 1).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <label>Actividad realizada</label>
                                <textarea className="form-control" value={bean.ActivityDescription} onChange={(e) => { setBean({ ...bean, ActivityDescription: e.target.value }) }} />
                            </div>

                            <div className="col-md-4">
                                <label>Estado</label>
                                <select className="form-select" value={bean.State} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, State: value })
                                }} >
                                    <option value="">...</option>
                                    <option value={1}>Reportado</option>
                                    <option value={2}>Asignado</option>
                                    <option value={3}>En Mantenimiento</option>
                                    <option value={4}>Finalizado</option>
                                </select>
                            </div>
                            <div className="col-md-12">
                                <AtachDocument _docList={document} onChange={(e) => { setDocument(e) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalImplements.modal} updateModal={modalImplements.setModal}>
                        <RequestMaintenanceImplements idRequestMaintenance={bean.IDRequestMaintenance} />
                    </Modal>

                    <Modal modal={modalExportList.modal} updateModal={modalExportList.setModal}>
                        {listaExport.length > 0 &&
                            <ExportXLSL customName={"Mantenimientos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </Modal>

                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { deleteItem() }} >
                        <strong>Eliminar item {bean.IDFixedAssetItemName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Mantenimientos Realizados">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}